'use strict';
import * as $j_app$002edata$002e$002dOrganization$002dWebsite$002dUri$0024package$0024$002dOrganization$002dWebsite$002dUri$0024 from "./app.data.-Organization-Website-Uri$package$-Organization-Website-Uri$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$() {
  this.aE3 = null;
  this.aE7 = null;
  this.aE6 = null;
  this.aDM = null;
  this.aE4 = null;
  this.aE5 = false;
  this.aDN = null;
  this.aDO = false;
  this.aDT = null;
  this.aDU = false;
  this.aDV = null;
  this.aDW = false;
  this.aE1 = null;
  this.aE2 = false;
  this.aDZ = null;
  this.aE0 = false;
  this.aDX = null;
  this.aDY = false;
  this.aDP = null;
  this.aDQ = false;
  this.aDR = null;
  this.aDS = false;
  $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ = this;
  this.aE3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_sttp$package$().bNl();
  this.aE7 = $j_app$002edata$002e$002dOrganization$002dWebsite$002dUri$0024package$0024$002dOrganization$002dWebsite$002dUri$0024.$m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUri$().bNO();
  this.aE6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_prelude_neotype\uff3fchimney$package$$anon$1();
  this.aDM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_sttp$package$().bNN();
}
export { $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ as $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ };
$p = $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$;
/** @constructor */
function $h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$() {
}
export { $h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ as $h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ };
$h_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$.prototype = $p;
$p.bZb = (function() {
  if ((!this.aE5)) {
    this.aE4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOfDifferentUnderlying__underlyingToValidated__Lio_scalaland_chimney_PartialTransformer(this);
    this.aE5 = true;
  }
  return this.aE4;
});
$p.bW = (function() {
  if ((!this.aDO)) {
    this.aDN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aDO = true;
  }
  return this.aDN;
});
$p.bNL = (function() {
  if ((!this.aDU)) {
    this.aDT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOfDifferentUnderlying$$anon$1(this);
    this.aDU = true;
  }
  return this.aDT;
});
$p.bNM = (function() {
  if ((!this.aDW)) {
    this.aDV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOfDifferentUnderlying__given_Transformer_TValidatedWrapper_Type__Lio_scalaland_chimney_Transformer(this);
    this.aDW = true;
  }
  return this.aDV;
});
$p.b3 = (function() {
  if ((!this.aE2)) {
    this.aE1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOfDifferentUnderlying$$anon$5(this);
    this.aE2 = true;
  }
  return this.aE1;
});
$p.az = (function() {
  if ((!this.aE0)) {
    this.aDZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOfDifferentUnderlying__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aE0 = true;
  }
  return this.aDZ;
});
$p.aY = (function() {
  if ((!this.aDY)) {
    this.aDX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aDY = true;
  }
  return this.aDX;
});
$p.bNe = (function() {
  if ((!this.aDQ)) {
    this.aDP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Website";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aDQ = true;
  }
  return this.aDP;
});
$p.bNG = (function() {
  if ((!this.aDS)) {
    this.aDR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aDS = true;
  }
  return this.aDR;
});
var $d_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$, "app.data.OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$", ({
  Ev: 1,
  YL: 1
}));
export { $d_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ as $d_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ };
var $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$;
function $m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$() {
  if ((!$n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$)) {
    $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ = new $c_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$();
  }
  return $n_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$;
}
export { $m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ as $m_Lapp_data_OrganizationWebsiteUri$package$OrganizationWebsiteUriForm$ };
//# sourceMappingURL=app.data.-Organization-Website-Uri$package$-Organization-Website-Uri-Form$.js.map
